export default "__VITE_ASSET__rUkiH63qcJGEQEedyX41xw__"